import { GroupBase, GroupProps, OnChangeValue } from 'react-select';

import isEqual from 'fast-deep-equal';

import cssClasses from './group.module.scss';

function Group<Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
  children,
  cx,
  data,
  getValue,
  getStyles,
  getClassNames,
  Heading,
  headingProps,
  label,
  theme,
  selectProps,
  setValue,
}: GroupProps<Option, IsMulti, Group>) {
  const { allowClickableHeader = false } = selectProps;

  return (
    <div
      className={cssClasses.group}
      onClick={(e) => {
        if (allowClickableHeader) {
          const currentValues = getValue();
          const { options } = data;
          const addedValues = options.filter((item) => currentValues.every((value) => !isEqual(value, item)));
          const updatedValues = Array.from(new Set([...(currentValues ?? []).concat(addedValues)]));

          e.stopPropagation();
          setValue(updatedValues as OnChangeValue<Option, IsMulti>, 'select-option');
        }
      }}>
      <Heading
        {...headingProps}
        cx={cx}
        getClassNames={getClassNames}
        getStyles={getStyles}
        selectProps={selectProps}
        theme={theme}>
        {label}
      </Heading>
      <div>{children}</div>
    </div>
  );
}

export default Group;
